<template>
  <header class="header">
    <div class="header__empty"></div>
    <div class="header__button left">
      <a href="https://eblitz.gg/" target="_blank">
        <button data-v-61dd7a3d="" class="header__button-auth">Home page</button>
      </a>
    </div>
    <div class="header__title">
      <div class="header__title-logo"><a href="https://eblitz.gg/"><svg width="63" height="68" viewBox="0 0 63 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M44.494 16.4404L53.0436 31.1015L51.5485 30.0171L45.8918 25.3606C43.1726 23.1218 40.6522 19.0444 44.494 16.4404ZM37.981 28.8215H17.2177L23.878 34.1681H44.6413L37.981 28.8215ZM37.1683 37.4622H16.405L23.0653 42.8086H43.8286L37.1683 37.4622ZM2.31909 0.193359L35.517 26.8436L13.9707 20.442C5.25621 17.8527 -4.57051 10.0988 2.31909 0.193359ZM62.7986 67.2677L41.6458 46.1029H31.2214L62.7986 67.2677ZM42.8401 13.1089C37.4795 13.8262 33.4547 19.1389 38.4112 23.1178L55.8344 37.1044C55.8959 37.0927 55.957 37.0811 56.0178 37.0692C56.0687 36.306 56.0947 35.536 56.0947 34.7598C56.0947 21.6626 48.7283 10.3164 37.9829 4.77969L42.8401 13.1089Z" fill="#FFD500"/>
      </svg>
      </a></div>
      <div class="header__title-name">
        <div>
          Receive exclusive access to eBlitz today!
        </div>
      </div>
    </div>

    <div class="header__button">
      <button class="header__button-auth" @click="logout" v-if="user">Sign Out</button>
      <button class="header__button-auth" @click="register" v-else-if="login_status">Sign Up</button>
      <button class="header__button-auth" @click="login" v-else>Sign In
      </button>
    </div>

  </header>

</template>

<script>
export default {
  name: "Header",
  computed: {
    user() {
      return this.$store.getters.user
    },
    login_status() {
      return this.$store.getters.login_status
    },
  },
  methods: {
    login() {
      this.$store.commit('updateLoginStatus',true)
    },
    register(){
      this.$store.commit('updateLoginStatus',false)
    },
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>
/*-----------------------------------------Header-----------------------------------------*/
.header {
  display: flex;
  justify-content: space-between;

  margin: 3.5rem 0;
  padding: 0 1rem;
}

.header__title {
  display: flex;
}

.header__title-logo {
  margin-right: 2.5rem;
}

.header__title-logo img {
  display: block;

  width: 3.15rem;
}

.header__title-name {
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-size: 2rem;
  color: #fff;
  text-align: center;
}
.header__button.left{
  margin-right: 10px;
}
.header__button.left a{
  color: #000!important;
}
.header__button {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header__button-auth {
  font-size: 1.1rem;

  padding: 1rem 2rem;

  border-radius: 10px;
  border: none;

  background-color: #FFD500;

  cursor: pointer;

  transition: background-color .1s linear;
}

.header__button-auth:active {
  background-color: #ba9b00;
}
@media (max-width: 600px) {
  .header__button-auth{
    font-size: 0.9rem;
    padding: 5px;
    height: 38px;
    width: 88px;
  }
  .header__title-name{
    font-size: 1rem!important;
    margin-right: 10px;
  }
  .header__title-logo a svg{
    width: 40px;
    height: 40px;
    margin-top: 10px;
  }
}
</style>